import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useContext, useEffect } from 'react';
import { FrameCount } from '../../../provider/FrameCountProvider';
import { RendererContext } from '../../../context';
import { forgePropsAreEqual } from '../../utils/forgePropsAreEqual';
var Frame = function Frame(_ref) {
  var forgeDoc = _ref.forgeDoc,
    IframeRenderer = _ref.IframeRenderer;
  var _useContext = useContext(FrameCount),
    setFrameCount = _useContext.setFrameCount;
  var _useContext2 = useContext(RendererContext),
    forgeEnvironment = _useContext2.forgeEnvironment;
  if (forgeEnvironment === 'PRODUCTION') {
    throw new Error('EAP features are only accessible to users with EAP signup and not supported or recommended for use in production.');
  }
  useEffect(function () {
    setFrameCount(function (prevCount) {
      return prevCount + 1;
    });
    return function () {
      return setFrameCount(function (prevCount) {
        return prevCount - 1;
      });
    };
  }, [setFrameCount]);
  var _ref2 = forgeDoc.props,
    resource = _ref2.resource,
    frameId = _ref2.frameId;
  return /*#__PURE__*/React.createElement(IframeRenderer, {
    resource: resource,
    frameId: frameId
  });
};
var FrameMemo = /*#__PURE__*/memo(Frame, forgePropsAreEqual);
export var makeFrame = function makeFrame(IframeRenderer) {
  return function (props) {
    return /*#__PURE__*/React.createElement(FrameMemo, _extends({}, props, {
      IframeRenderer: IframeRenderer
    }));
  };
};